import { STORAGE_COMPONENT_IDS } from '../../componentIds';
export class CornerRegularFrameComponent {
    static id = STORAGE_COMPONENT_IDS.CornerRegularFrameComponent;
    typeId = CornerRegularFrameComponent.id;
    doStoreInSnapshot = true;
    serializable = false;
    eq() {
        return true;
    }
}
//# sourceMappingURL=CornerRegularFrameComponent.js.map